import axios from 'axios';
import { FETCH_D2C_REQUEST, FETCH_D2C_ERROR, FETCH_D2C_DATA, RESET_D2C_VIEW_DATA, FETCH_D2C_EVENT } from './d2cTypes';
import BASE_URL from '../config';

const timeout = 120000;

export const fetchRequestEvents = (msg) => {
  return {
    type: FETCH_D2C_REQUEST,
    payload: [msg]
  };
};

export const resetD2CData = () => {
  return {
    type: RESET_D2C_VIEW_DATA,
    payload: []
  };
};

export const fetchD2CData = (campaign_list) => (dispatch, getState) => {
  console.log('Fetching D2C data with params:', {
    campaignList: campaign_list,
    startDate: getState().campaignReducer.start_date,
    endDate: getState().campaignReducer.end_date
  });

  dispatch(fetchRequestEvents('loading'));

  return axios({
    method: 'post',
    url: `${BASE_URL}/getD2CRequestData`,
    headers: {
      'Content-Type': 'application/json'
    },
    data: {
      userEmail: getState().userReducer.userEmail,
      //   CampaignIds: campaign_list,
      advertiser_id: localStorage.getItem('advertiserId'),
      sfId: localStorage.getItem('sfId'),
      startDate: getState().campaignReducer.start_date,
      endDate: getState().campaignReducer.end_date
      //   timeZone: getState().advertiserReducer.timeZone
    },
    timeout: timeout
  })
    .then((response) => {
      console.log('D2C API Response:', response.data);
      if (response.data && Array.isArray(response.data) && response.data.length > 0) {
        const d2cData = response.data[0].overview;

        if (Array.isArray(d2cData) && d2cData.length > 0) {
          console.log('✅ Found D2C overview data:', d2cData);
          return dispatch(fetchedDoDDetails(d2cData));
        }
      }

      console.log('No valid D2C data found in response');
      return dispatch(fetchD2CRequestError('No data found'));
    })
    .catch((error) => {
      console.error('D2C API Error:', error);
      const errorMessage = error.response?.data?.message || 'Not able to fetch data. Please try again';
      return dispatch(fetchD2CRequestError(errorMessage));
    });
};

export const fetchEventData = (msg) => {
  return {
    type: FETCH_D2C_EVENT,
    payload: [msg]
  };
};

export const fetchD2CRequestData = (campaign_list) => (dispatch, getState) => {
  console.log('Fetching D2C data with params:', {
    campaignList: campaign_list,
    startDate: getState().campaignReducer.start_date,
    endDate: getState().campaignReducer.end_date
  });

  dispatch(fetchEventData('loading'));

  return axios({
    method: 'post',
    url: `${BASE_URL}/getD2CEventData`,
    headers: {
      'Content-Type': 'application/json'
    },
    data: {
      userEmail: getState().userReducer.userEmail,
      //   CampaignIds: campaign_list,
      advertiser_id: localStorage.getItem('advertiserId'),
      sfId: localStorage.getItem('sfId'),
      startDate: getState().campaignReducer.start_date,
      endDate: getState().campaignReducer.end_date
      //   timeZone: getState().advertiserReducer.timeZone
    },
    timeout: timeout
  })
    .then((response) => {
      console.log('D2C API Response:', response.data);
      if (response.data && Array.isArray(response.data) && response.data.length > 0) {
        const d2cData = response.data[0].overview;

        if (Array.isArray(d2cData) && d2cData.length > 0) {
          console.log('✅ Found D2C overview data:', d2cData);
          return dispatch(fetchedD2CEventDetails(d2cData));
        }
      }
      console.log('No valid D2C data found in response');
      return dispatch(fetchD2CRequestError('No data found'));
    })
    .catch((error) => {
      console.error('D2C API Error:', error);
      const errorMessage = error.response?.data?.message || 'Not able to fetch data. Please try again';
      return dispatch(fetchD2CRequestError(errorMessage));
    });
};

function detectKeys(jsonData) {
  const keys = new Set();
  jsonData.forEach((obj) => {
    Object.keys(obj).forEach((key) => {
      keys.add(key);
    });
  });
  return Array.from(keys);
}

export const fetchedDoDDetails = (data) => {
  console.log('Processing data in fetchedDoDDetails:', data);
  const detectedKeys = detectKeys(data);
  console.log('Detected keys:', detectedKeys);

  const dodDetailsWithIds = data.map((item, index) => ({
    id: index,
    ...item
  }));

  console.log('Processed data:', dodDetailsWithIds);

  return {
    type: FETCH_D2C_DATA,
    payload: dodDetailsWithIds
  };
};

export const fetchedD2CEventDetails = (data) => {
  console.log('Processing data in fetchedDoDDetails:', data);
  const detectedKeys = detectKeys(data);
  console.log('Detected keys:', detectedKeys);

  const dodDetailsWithIds = data.map((item, index) => ({
    id: index,
    ...item
  }));

  console.log('Processed data:', dodDetailsWithIds);

  return {
    type: FETCH_D2C_DATA,
    payload: dodDetailsWithIds
  };
};

export const fetchD2CRequestError = (error) => {
  return {
    type: FETCH_D2C_ERROR,
    payload: error
  };
};
